// import { isServer } from '@vue-storefront/core/helpers'
// import buildTimeConfig from 'config'
const bgColorStyle = ( color ) => `color: white; background: ${color}; padding: 4px; font-weight: bold; font-size: 0.8em'`

class Logger {
  constructor (
    verbosityLevel = 'display-everything',
    showErrorOnProduction = false
  ) {
    this.verbosityLevel = verbosityLevel
    this.showErrorOnProduction = showErrorOnProduction
    this.isProduction = process.env.NODE_ENV === 'production'
  }

  convertToString ( payload ) {
    if ( typeof payload === 'string' || typeof payload === 'boolean' ||
         typeof payload === 'number' ) return payload
    if ( payload && payload.message ) return payload.message
    return JSON.stringify( payload )
  }

  canPrint ( method ) {
    const allowedMethods = []

    if ( this.verbosityLevel === 'display-everything' &&
         this.isProduction === false ) {
      allowedMethods.push( ...[ 'info', 'warn', 'error', 'debug' ])
    } else if ( this.verbosityLevel === 'only-errors' &&
                ( this.isProduction === false ||
                  this.showErrorOnProduction === true )) {
      allowedMethods.push( 'error' )
    }
    return allowedMethods.indexOf( method ) !== -1
  }

  debug ( message, tag = null, context = null) {
    if ( !this.canPrint( 'debug' )) {
      return () => {}
    }

    // if ( isServer ) {
    //   return console.debug.bind( console, (tag ? `[${tag}] ` : '' ) +
    //                              this.convertToString( message ), context )
    // }

    if ( tag ) {
      return console.debug.bind(
        window.console, '%cBSH%c %c' + tag + '%c ' +
           this.convertToString( message ),
        bgColorStyle( 'grey' ),
        'color: inherit',
        bgColorStyle( 'gray' ),
        'font-weight: normal',
        context
      )
    } else {
      return console.debug.bind(
        window.console, '%cBSH%c ' + this.convertToString( message ),
        bgColorStyle( 'grey' ),
        'font-weight: normal',
        context
      )
    }
  }

  log ( message, tag = null, context = null ) {
    return this.info( message, tag, context )
  }

  info ( message, tag = null, context = null) {
    if ( !this.canPrint( 'info' )) {
      return () => {}
    }

    // if ( isServer ) {
    //   return console.log.bind(
    //     console,
    //     ( tag ? `[${tag}] ` : '') + this.convertToString(message),
    //     context
    //   )
    // }

    if ( tag ) {
      return console.log.bind(
        window.console,
        '%cBSH%c %c' + tag + '%c ' + this.convertToString( message ),
        bgColorStyle( 'green' ),
        'color: inherit',
        bgColorStyle( 'gray' ),
        'font-weight: bold',
        context
      )
    } else {
      return console.log.bind(
        window.console,
        '%cBSH%c ' + this.convertToString( message ),
        bgColorStyle( 'green' ),
        'font-weight: bold',
        context
      )
    }
  }

  warn ( message, tag = null, context = null ) {
    if ( !this.canPrint( 'warn' )) {
      return () => {}
    }
    // if ( isServer ) {
    //   return console.warn.bind(
    //     console,
    //     ( tag ? `[${tag}] ` : '' ) + this.convertToString( message ),
    //     context
    //   )
    // }

    if ( tag ) {
      return console.warn.bind(
        window.console,
        '%cBSH%c %c' + tag + '%c ' + this.convertToString( message ),
        bgColorStyle( 'orange' ),
        'color: inherit',
        bgColorStyle( 'gray' ),
        'font-weight: bold',
        context
      )
    } else {
      return console.warn.bind(
        window.console,
        '%cBSH%c ' + this.convertToString( message ),
        bgColorStyle( 'orange' ),
        'font-weight: bold',
        context
      )
    }
  }

  error ( message, tag = null, context = null ) {
    // if ( isServer ) { // always show errors in SSR
    //   return console.error.bind(
    //     console,
    //     ( tag ? `[${tag}] ` : '' ) + this.convertToString( message ),
    //     context
    //   )
    // }

    if (this.canPrint( 'error' )) {
      if ( tag ) {
        return console.error.bind(
          window.console,
          '%cBSH%c %c' + tag + '%c ' + this.convertToString( message ),
          bgColorStyle( 'red' ),
          'color: inherit',
          bgColorStyle( 'gray' ),
          'font-weight: bold',
          context
        )
      } else {
        return console.error.bind(
          window.console,
          '%cBSH%c ' + this.convertToString( message ),
          bgColorStyle( 'red' ),
          'font-weight: bold',
          context
        )
      }
    }
    return () => {}
  }
}

const logger = new Logger( 'display-everything', false )

export { logger as Logger }
